import React from "react";
import Label from "../FormComponents/Label";
import Input from "../FormComponents/Input";
import Button from "../FormComponents/Button";
import ButtonActionIcon from "../BuilderComponents/ButtonActionIcon";
import FieldSelectorFromPopup from "../BuilderComponents/FieldSelectorFromPopup";
import { generateObjectId } from "../../utils/objectIdUtils";

const EditRvTabFilterForPosition = ({ editElementData, setEditElementData, tableId, tableType }) => {
  const handleAddFilter = (f) => {
    setEditElementData({ ...editElementData, filter_field: f });
  };
  const addPlaceholder = () => {
    setEditElementData({
      ...editElementData,
      placeholder: [...editElementData.placeholder, { id: generateObjectId(), label: "" }]
    });
  };

  const handleChangePlaceholder = (value, index) => {
    const updatedPlaceholders = [...editElementData.placeholder];
    updatedPlaceholders[index].label = value;
    setEditElementData({ ...editElementData, placeholder: updatedPlaceholders });
  };

  const deletePlaceholder = (index) => {
    const updatedPlaceholders = [...editElementData.placeholder];
    updatedPlaceholders.splice(index, 1);
    setEditElementData({ ...editElementData, placeholder: updatedPlaceholders });
  };

  return (
    <div className="builder_form">
      <div className="builder_form">
        <Label>Select Filter Field</Label>
        <FieldSelectorFromPopup
          tableId={tableId}
          tableType={tableType}
          fieldId={editElementData.filter_field?.id || ""}
          onSelect={handleAddFilter}
        />
      </div>
      <div>
        <div className="d_flex justify_between">
          <Label>Add Placeholder</Label>
          <Button variant="secondary" size="small" onClick={addPlaceholder} className="mb_2">
            Add
          </Button>
        </div>
        {editElementData.placeholder.map((p, i) => (
          <div key={p.id} className="d_flex align_center gap_2 mb_2">
            <Input
              value={p.label}
              onChange={(e) => handleChangePlaceholder(e.target.value, i)}
              placeholder="Enter Placeholder"
            />
            <ButtonActionIcon type="delete" onClick={() => deletePlaceholder(i)} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default EditRvTabFilterForPosition;
